<template>
    <div class="my-tooltip">
        <span
            data-toggle="tooltip"
            @mouseenter="show = true"
            @mouseleave="show = false"
        >
            <slot name="outer"></slot>
        </span>

        <div
            v-if="show && hasInnerSlot"
            class="tooltip bs-tooltip-top show"
            role="tooltip"
        >
            <div class="arrow"></div>

            <div class="tooltip-inner">
                <slot name="inner">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
            }
        },
        computed:{
            hasInnerSlot() {
                return !!this.$slots.inner
            }
        }
    }

</script>
